import { Provider, observer } from "mobx-react";
import React, { FC } from "react";
import {
  Location,
  Navigate,
  NavigateFunction,
  Params,
  Route,
  Routes,
} from "react-router-dom";
import ItemDetailPageMain from "./ItemDetailPageMain";
import Items from "./Items";
import { withRouter } from "@mindmemobile/mm-shared-global";
import { ItemsStore, RolesAndPermissionStore } from "../../../shared/store";
import { DashboardGrid } from "../../../shared/styles";
import { MerchantAccountStore } from "../../../modules/merchantAccounts";

interface IProps {
  navigate: NavigateFunction;
  params: Readonly<Params<string>>;
  location: Location;
  itemStore: ItemsStore;
  rolesAndPermissionStore: RolesAndPermissionStore;
  merchantAccountStore: MerchantAccountStore;
}

const ItemsMain: FC<IProps> = ({
  itemStore,
  rolesAndPermissionStore,
  merchantAccountStore,
}) => {
  function routes() {
    return (
      <Routes>
        <Route
          path={`/`}
          element={
            <Items
              itemStore={itemStore}
              rolesAndPermissionStore={rolesAndPermissionStore}
              merchantAccountStore={merchantAccountStore}
            />
          }
        />
        <Route
          path={`/detail/:id/:type/:name`}
          element={
            <Provider itemStore={itemStore}>
              <ItemDetailPageMain
                merchantAccountStore={merchantAccountStore}
                rolesAndPermissionStore={rolesAndPermissionStore}
              />
            </Provider>
          }
        />
        <Route path="*" element={<Navigate to="/items" />} />
      </Routes>
    );
  }

  return (
    <>
      <DashboardGrid>{routes()}</DashboardGrid>
    </>
  );
};

export default withRouter(observer(ItemsMain));
